export default {
	"DetailList.LongPressToIdentifyTheQRCode": "長按識別二維碼",
	"DetailList.enter": "進入",
	"DetailList.TheAppletViewsTheContent": "小程式查看內容",
	"DetailList.TheFollowingItemsAreIncluded": "包含以下商品",
	"DetailList.Gifts": "贈品",
	"DetailList.Real": "實物"
}